import { Api } from "../config/request";

export default {
  getObDetails(queryParams) {
    return Api.get(`/driver-onboarding/application_details?${queryParams}`);
  },

  connectOutGoingCall(body) {
    return Api.post(`/driver-onboarding/connect_outgoing_call`, body);
  },

  getObCallLogs(queryParams) {
    return Api.get(`/driver-onboarding/call-logs?${queryParams}`);
  }
};
